import createReducer from '../utils/createReducer';
import actions from '../actions/companyLocation';
import {getComponentState} from '../utils/localStorageDataHandler';
import businessTypeMapper from '../utils/businessTypeMapper';
import {checkCompanyLocBtnStatus, isAuSite, isEMEABrandSite, isNzSite, isUsSite, excludeTaxIdentifier} from '../utils/validate';

const initialState = {};

const actionHandlers = {
    [actions.GET_LOCATION_METADATA_SUCCESS](state, {payload}) {
        return {
            ...state,
            countryList: payload.locationMetadata.countryList
        };
    },

    [actions.SET_COMPANY_LOCATION](state, {payload}) {
        return {
            ...state,
            companyCountryCode: payload.fieldVal,
            companyCountryCodeError: ''
        };
    },

    [actions.COMPANY_LOCATION_FIELD_ERROR](state, {payload}) {
        return {
            ...state,
            companyCountryCode: '',
            companyCountryCodeError: payload.errorKey
        };
    },

    [actions.TOGGLE_COMPANY_LOC_CONTINUE_BUTTON](state, {}) {
        const result = (state.companyCountryCode) ? true : false;

        return {
            ...state,
            enableContinueButton: result
        };
    },

    [actions.COMPANY_LOCATION_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.DISMISS_ALERT_BOX](state, {}) {
        return {
            ...state,
            serviceError: ''
        };
    },

    [actions.PRE_POPULATE_LOCAL_STATE_COMP_LOC](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'companyLocation');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state
        };
    },

    [actions.HANDLE_COMP_LOC_FIELD_VALUE_CHANGE](state, {payload}) {
        const countryList = state.countryList;
        switch (payload.fieldName) {
            case 'companyName': return {
                ...state,
                companyName: payload.fieldValue,
            };

            case 'companyLocation': return {
                ...state,
                companyCountryCode: payload.fieldValue,
                companyCountryInfo: (countryList instanceof Array) ? countryList.find((e) => e.countryCode === payload.fieldValue) : null
            };

            case 'vatChoiceYes': return {
                ...state,
                vatChoice: 'Yes',
                registrationNumberChoice: 'No',
                registrationNumber: ''
            };

            case 'vatChoiceNo': return {
                ...state,
                vatChoice: 'No',
            };

            case 'registrationNumberYes': return {
                ...state,
                registrationNumberChoice: 'Yes',
            };

            case 'registrationNumberNo': return {
                ...state,
                registrationNumberChoice: 'No',
                registrationNumber: ''
            };

            case 'registrationNumber': return {
                ...state,
                registrationNumber: payload.fieldValue,
            };

            case 'businessType': return {
                ...state,
                businessType: payload.fieldValue,
            };

            default: return {
                ...state
            };
        }
    },

    [actions.SET_COMPANY_LOCATION_FIELD_ERROR](state, {payload}) {
        switch (payload.fieldName) {
            case 'companyName': return {
                ...state,
                companyNameError: payload.msg
            };

            case 'companyLocation': return {
                ...state,
                companyCountryCodeError: payload.msg
            };

            case 'registrationNumber': return {
                ...state,
                registrationNumberError: payload.msg
            };

            case 'businessType': return {
                ...state,
                businessTypeError: payload.msg
            };

            default: return {
                ...state
            };
        }
    },

    [actions.VERIFY_SITE](state, {payload}) {
        let showVatChoice = false;
        let showBusinessType = false;
        let businessTypes = {};

        if (!isUsSite(payload.siteName) && !isAuSite(payload.siteName) && !isNzSite(payload.siteName)) {
            showVatChoice = true;
            showBusinessType = true;
            businessTypes = businessTypeMapper(payload.siteName);
        }

        return {
            ...state,
            showVatChoice,
            showBusinessType,
            businessTypes
        };
    },

    [actions.TOGGLE_REGISTRATION_NUMBER_FIELD](state, {payload}) {
        let showRegistrationNumberChoice = false;
        if (payload.fieldValue === 'No' && (isEMEABrandSite(payload.siteName)) && (!excludeTaxIdentifier(state.companyCountryCode))) {
            showRegistrationNumberChoice = true;
        }
        return {
            ...state,
            showRegistrationNumberChoice
        };
    },

    [actions.SET_REGISTRATION_NUMBER_FIELD](state, {payload}) {
        let showRegistrationNumberChoice = false;
        if ((state.vatChoice === 'No') && (isEMEABrandSite(payload.siteName)) && (!excludeTaxIdentifier(payload.fieldValue))) {
            showRegistrationNumberChoice = true;
        }
        return {
            ...state,
            showRegistrationNumberChoice,
            registrationNumberChoice: 'No',
            registrationNumber: ''
        };
    },


    [actions.TOGGLE_COMP_LOC_CONTINUE_BUTTON](state, {}) {
        const enableContinueButton = checkCompanyLocBtnStatus(state);
        return {
            ...state,
            enableContinueButton
        };
    }

};

export default createReducer(actionHandlers, initialState);
